"use strict";
/**
 * Strip ARIA roles that Foundation 6.7's accordion-menu / responsive-menu
 * applies to the primary nav. Foundation sets role="tablist" on the <ul>
 * and role="menuitem" on each <li>, which is an invalid ARIA pairing
 * (tablist requires role="tab" children; menuitem requires role="menu"
 * or "menubar" parent). The visual behavior is fine without those roles --
 * the semantic <ul>/<li>/<a> structure is correct on its own.
 *
 * Concatenated by Gulp after init-foundation.js (alphabetical order),
 * so by the time this runs Foundation has already decorated the DOM.
 */
(function ($) {
    $(function () {
        var $nav = $('#menu-navigation');
        if (!$nav.length)
            return;
        $nav.removeAttr('role aria-multiselectable');
        $nav.find('> li').removeAttr('role');
    });
})(jQuery);
